/**
 * Styling and wording for a quoted cell flagged "Different Than Requested",
 * taken from the CPD-174 designs in the CENTRO-APP Figma file (node
 * 38308-268218).
 */

/** Cell fill: the design token `color/yellow/50`. */
export const CELL_DIFFERENCE_BG = "#FCF8E8";

/** Colour of the flag icon at the cell's left edge. */
export const CELL_DIFFERENCE_ICON_COLOR = "#E69238";

/** Tooltip background: the design token `tooltip/bgcolor`. */
export const DIFFERENCE_TOOLTIP_BG = "#383838";

export const DIFFERENCE_TOOLTIP_TEXT =
  "Differs from requested value. Use the cell actions menu to dismiss the flag.";

export const DISMISS_DIFFERENCE_LABEL = "Dismiss Different than Requested";
